<template>
  <div class="user-manage">
    <div class="user-manage-content">
      <div class="user-manage-content-top">
        <div class="user-manage-content-top-left">
          <p class="user-manage-content-top-left-title">用户</p>
          <button class="user-manage-content-top-left-add-user" @click="onAddClick">
            新增用户
          </button>
          <button v-if="isAdmin" class="user-manage-content-top-left-import-user" @click="onImportClick">
            一键导入
          </button>
        </div>
        <keyword-search title="姓名或手机号" @onKeywordSearch="onKeywordSearch"></keyword-search>
      </div>
      <page-list-container class="user-manage-content-bottom-list" :total="total" :pageSize="pageSize"
        :inputCurrentPage="currentPage" @onPageChange="onPageChange" @onSizeChange="onSizeChange">
        <user-table :list="userArray" :showRecord="hospitalID === 503" @delete="onCellDeleteClick"
          @detail="onCellDetailClick" @edit="onCellEditClick" @preview="onCellPreviewClick"
          @record="onCellRecordClick" />
      </page-list-container>
    </div>

    <!-- 使用新的统一用户弹窗组件 -->
    <user-dialog v-if="isShowUserDialog" :isEdit="!!selectedModel" :model="selectedModel"
      @onCloseClick="onUserDialogCloseClick" @onConfirmClick="onUserDialogConfirmClick"
      @onQrCodeClick="onQrCodeClick"></user-dialog>

    <!-- 用户详情组件 -->
    <user-detail v-if="isShowUserDetail" :userId="selectedID" :hospitalId="selectedHospitalID"
      @onCloseClick="onUserDetailCloseClick"></user-detail>

    <!-- 用户二维码组件 -->
    <user-qrcode v-if="isShowUserQrcode" :hospitalID="hospitalID" :hospitalName="hospitalName"
      @onCloseClick="onUserQrcodeCloseClick"></user-qrcode>

    <!-- 导入用户弹窗 -->
    <import-user-dialog v-if="isShowImportDialog" @onCloseClick="onImportDialogCloseClick"
      @onImportSuccess="onImportSuccess"></import-user-dialog>

    <report-panel v-if="isShowReportPanel" :dataArray="reportArray" @onCloseClick="onReportPanelCloseClick"
      @onPreviewClick="onReportPanelPreviewClick"></report-panel>

    <user-info-record-dialog v-if="isShowInfoRecordDialog" :user="selectedModel" @close="onInfoRecordDialogClose"
      @save="onInfoRecordDialogSave" />
  </div>
</template>

<script>
import KeywordSearch from "@c/common/keyword-search.vue";
import UserTable from "./user-table.vue";
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import UserDialog from "./user-dialog.vue";
import UserDetail from "./user-detail.vue";
import UserQrcode from "./user-qrcode.vue";
import ReportPanel from "./report-panel/report-panel.vue";
import ImportUserDialog from "./import-user-dialog.vue";
import UserInfoRecordDialog from "./user-info-record-dialog.vue";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import dayjs from "dayjs";
import { DateTool } from "@js/date-tool.js";
import { UserModel } from "./user-model.js";

export default {
  components: {
    KeywordSearch,
    UserTable,
    PageListContainer,
    UserDialog,
    UserDetail,
    UserQrcode,
    ReportPanel,
    ImportUserDialog,
    UserInfoRecordDialog,
  },

  data: function () {
    return {
      //userList
      userArray: [],
      total: undefined, // 显示总条数
      pageSize: undefined, // 每页显示条数
      currentPage: 1, // 当前的页数
      //keywords
      keywords: "",
      //cell
      selectedModel: undefined,
      //user dialog (add/edit)
      isShowUserDialog: false,
      //user detail
      isShowUserDetail: false,
      //user qrcode
      isShowUserQrcode: false,
      //report-panel
      isShowReportPanel: false,
      reportArray: [],
      //import dialog
      isShowImportDialog: false,
      // info record dialog
      isShowInfoRecordDialog: false,
    };
  },

  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    },
    hospitalName: function () {
      return this.$store.state.selectedHospital.name;
    },
    isAdmin: function () {
      //对高级系统管理员和湖州中心医院体检中心几个人员开放
      return this.$store.state.accountInfo?.roleName === '高级系统管理员'
        || this.$store.state.accountInfo.id === 2685
        || this.$store.state.accountInfo.id === 2684
        || this.$store.state.accountInfo.id === 2663
        || this.$store.state.accountInfo.id === 88
        || this.$store.state.accountInfo.id === 850
        || this.$store.state.accountInfo.id === 700
        || this.$store.state.accountInfo.id === 2887
    },

    selectedID: function () {
      return this.selectedModel == undefined
        ? undefined
        : this.selectedModel.id;
    },
    selectedHospitalID() {
      return this.selectedModel == undefined
        ? undefined
        : this.selectedModel.hospitalId;
    },
  },

  watch: {
    hospitalID: function () {
      this.currentPage = 1;
      this.userListRequest();
    },
  },

  mounted() {
    this.pageSize = bestPageSizeComputer();
    this.userListRequest();
  },

  methods: {
    onAddClick: function () {
      if (this.hospitalID === null) {
        this.$toast.showRed(MSG.pickHospitalRemind);
        return;
      }
      // 打开新增用户弹窗
      this.selectedModel = null;
      this.isShowUserDialog = true;
    },

    onKeywordSearch: function (value) {
      this.currentPage = 1;
      this.keywords = value;
      this.userListRequest();
    },

    onCellEditClick: function (data) {
      // 打开编辑用户弹窗
      this.selectedModel = data
      this.isShowUserDialog = true;
    },

    onCellDeleteClick: function (data) {
      this.selectedModel = data
      this.$alert.show("用户操作", "是否要删除用户？", () => {
        this.userDeleteRequest();
      });
    },

    onCellDetailClick: function (data) {
      this.selectedModel = data
      // 打开用户详情弹窗
      this.isShowUserDetail = true;
    },

    async onCellPreviewClick(data) {
      this.selectedModel = data
      await this.reportListRequest(this.selectedModel.id);
      if (
        this.reportArray.length === 1 &&
        this.reportArray[0].complete === "完整"
      ) {

        const firstReport = this.reportArray[0];
        const { deviceType } = firstReport
        if (deviceType === 1) {
          ReportPreviewTool.previewNewReport(
            this.selectedModel.truename,
            firstReport.reportNumber,
            firstReport.createDat,
            deviceType,
          )
        } else {
          ReportPreviewTool.previewReport(
            this.selectedModel.truename,
            firstReport.reportNumber,
            firstReport.createDat
          );
        }

      } else {
        this.isShowReportPanel = true;
      }
    },

    onCellRecordClick(data) {
      this.selectedModel = data
      this.isShowInfoRecordDialog = true;
    },

    //分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.userListRequest();
    },

    onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.userListRequest();
    },

    // UserDialog 组件回调
    onUserDialogCloseClick: function () {
      this.isShowUserDialog = false;
    },

    onUserDialogConfirmClick: function (info) {
      if (info.id) {
        // 编辑模式
        this.userEditRequest(info);
      } else {
        // 新增模式
        this.userCreateRequest(info);
      }
      this.isShowUserDialog = false;
    },

    onQrCodeClick() {
      this.isShowUserQrcode = true;
      this.isShowUserDialog = false;
    },

    // UserDetail 组件回调
    onUserDetailCloseClick: function () {
      this.isShowUserDetail = false;
    },

    onUserDetailEditClick: function (userDetail) {
      this.isShowUserDetail = false;
      this.selectedModel = userDetail;
      this.isShowUserDialog = true;
    },

    onUserDetailQrcodeClick: function (userDetail) {
      this.isShowUserDetail = false;
      this.isShowUserQrcode = true;
    },

    onUserDetailReportsClick: function (userDetail) {
      this.isShowUserDetail = false;
      this.onCellPreviewClick();
    },

    // UserQrcode 组件回调
    onUserQrcodeCloseClick: function () {
      this.isShowUserQrcode = false;
    },

    //report-panel
    onReportPanelCloseClick: function () {
      this.isShowReportPanel = false;
    },

    onReportPanelPreviewClick: function (selectedReportModel) {
      const { deviceType } = selectedReportModel
      if (deviceType === 1) {
        ReportPreviewTool.previewNewReport(
          this.selectedModel.truename,
          selectedReportModel.reportNumber,
          selectedReportModel.createDat,
          deviceType,
        )
      } else {
        ReportPreviewTool.previewReport(
          this.selectedModel.truename,
          selectedReportModel.reportNumber,
          selectedReportModel.createDat
        );
      }

    },

    //request
    async userListRequest() {
      try {
        const params = {
          keyWord: this.keywords,
          pageNum: this.currentPage,
          hospitalId: this.hospitalID,
          pageSize: this.pageSize,
        };
        const response = await this.$api.getUserPageList(params);
        this.total = response.total;
        this.userArray = UserModel.fromApiResponse(response);
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async reportListRequest(uid) {
      try {
        const params = {
          hospitalId: this.hospitalID,
          uid: uid,
        };
        const response = await this.$api.getSleepReportList(params);
        this.reportArray = response;
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async userDeleteRequest() {
      try {
        const params = {
          id: this.selectedModel.id,
        };
        await this.$api.deleteUser(params);
        this.$toast.showGreen(MSG.userDeleteSucceed);
        this.userListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async userCreateRequest(info) {
      try {
        const params = {
          trueName: info.name,
          birthday: info.birthday,
          height: info.height,
          weight: info.weight,
          sex: info.isFemale ? GENDER_CODE.女 : GENDER_CODE.男,
          mobile: info.phone,
          address: info.address,
          hospitalId: this.hospitalID,
          mzh: info.number,
          idCard: info.ID,
          bch: info.bch,
          department: info.department,
          frontPhoto: info.frontPhoto,
          leftPhoto: info.leftPhoto,
          rightPhoto: info.rightPhoto,
          remarks: info.remarks,
          hipCircumference: info.hipCircumference,
          waistCircumference: info.waistCircumference,
          neckCircumference: info.neckCircumference,
        };
        await this.$api.createUser(params);
        this.$toast.showGreen(MSG.userAddSucceed);
        this.currentPage = 1;
        this.keywords = "";
        this.userListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async userEditRequest(info) {
      try {
        const params = {
          id: this.selectedModel.id,
          trueName: info.name,
          birthday: info.birthday,
          height: info.height,
          weight: info.weight,
          sex: info.isFemale ? GENDER_CODE.女 : GENDER_CODE.男,
          mobile: info.phone,
          address: info.address,
          hospitalId: info.hospitalId,
          mzh: info.number,
          idCard: info.ID,
          bch: info.bch,
          department: info.department,
          frontPhoto: info.frontPhoto,
          leftPhoto: info.leftPhoto,
          rightPhoto: info.rightPhoto,
          remarks: info.remarks,
          hipCircumference: info.hipCircumference,
          waistCircumference: info.waistCircumference,
          neckCircumference: info.neckCircumference,
        };
        await this.$api.editUser(params);
        this.$toast.showGreen(MSG.userEditSucceed);
        this.currentPage = 1;
        this.keywords = "";
        this.userListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    onImportClick() {
      if (this.hospitalID === null) {
        this.$toast.showRed(MSG.pickHospitalRemind);
        return;
      }
      this.isShowImportDialog = true;
    },

    onImportDialogCloseClick() {
      this.isShowImportDialog = false;
    },

    onImportSuccess() {
      this.userListRequest();
    },

    calculateAge(birthday) {
      if (!birthday) return '-';
      const birthDay = dayjs(birthday);
      if (!birthDay.isValid()) {
        return "-";
      }
      return DateTool.calculateAge(
        birthDay.year(),
        birthDay.month() + 1,
        birthDay.date()
      );
    },

    // 信息记录弹窗回调
    onInfoRecordDialogClose() {
      this.isShowInfoRecordDialog = false;
    },
    onInfoRecordDialogSave(recordData) {
      this.isShowInfoRecordDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-manage {
  background-color: #eff2f7;
  width: 100%;

  &-content {
    background-color: white;
    border-radius: rem(2);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-left: rem(36);
    padding-right: rem(33);
    display: flex;
    flex-direction: column;
    align-items: center;

    &-top {
      font-size: rem(16);
      width: 100%;
      height: rem(72);
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-left {
        display: flex;

        &-title {
          color: #325fac;
          font-size: rem(14);
          border-bottom: rem(2) solid #325fac;
          width: rem(100);
          height: rem(32);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &-add-user {
          color: white;
          background-color: #325fac;
          font-size: rem(14);
          width: rem(88);
          height: rem(32);
          border-radius: 4px;
          margin-left: rem(74);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &-import-user {
          color: white;
          background-color: #325fac;
          font-size: rem(14);
          width: rem(88);
          height: rem(32);
          border-radius: 4px;
          margin-left: rem(10);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    &-bottom {
      width: 100%;
      height: 100%;
      margin-top: rem(26);
      display: flex;
      flex-direction: column;
      align-items: center;

      &-list {
        width: 100%;
      }

      &-empty-info {
        color: rgba($color: black, $alpha: 0.85);
        font-size: rem(14);
        width: 100%;
        margin-top: rem(100);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-pagination {
        width: 100%;
        height: rem(90);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
